import { PageBreak, Document, Packer, Paragraph, TextRun, ImageRun, WidthType, TableCell, Table, TableRow, convertInchesToTwip, BorderStyle } from "docx";
import { saveAs } from "file-saver";
import pdfImage from "../../components/PDF/pdfImage";

export const RPT245Word = (dataReport, dataRPTScore, setLoading) => {
    const cellBorder = {
        noBorder: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        line: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        noRight: { right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        noLeft: { left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        borderButton: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
    };

    const font = {
        size: {
            xxl: 28,
            xl: 28,
            p: 28,
            tbHeader: 28,
            tbbody: 28,
        },
        SarabunPSK: "TH SarabunPSK",
    };

    const handlerCheck = (key) => {
        return key === "Y" ? pdfImage.checkBox : pdfImage.unchecked;
    };

    const c = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                verticalAlign: "top",
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: pdfImage.logoPWA_1,
                                                                transformation: {
                                                                    width: 200,
                                                                    height: 70,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: {
                                                    top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                    left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                    bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                },
                                                verticalAlign: "center",
                                                margins: { left: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.xxl,
                                                                text: "การประปานครหลวง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                margins: { left: convertInchesToTwip(0.1) },
                                                verticalAlign: "center",
                                                borders: {
                                                    top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                    right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                    bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: pdfImage.unchecked,
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                bold: true,
                                                                size: font.size.tbbody,
                                                                text: "   ฝกจ ......  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck(dataReport[0].branchFlag),
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                bold: true,
                                                                size: font.size.tbbody,
                                                                text: "   " + dataReport[0].branchAbbName + "  ",
                                                                underline: { type: "dotted" },
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: pdfImage.unchecked,
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                bold: true,
                                                                size: font.size.tbbody,
                                                                text: "   ...........",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c2 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "top",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        size: font.size.p,
                                        text: "ใบประเมินผลงานของผู้รับจ้าง",
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "top",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        size: font.size.p,
                                        text: "สำหรับงานก่อสร้างวางท่อจ่ายน้ำและงานซ่อมท่อ ทุกสัญญา",
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c3 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "ระยะเวลาการประเมิน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                verticalAlign: "bottom",
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: " ................................ ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(0.3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(dataReport[0].assessmentFlag1),
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "   ระหว่างก่อสร้างจาก    ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: dataReport[0].assessmentBeginDate,
                                                                underline: { type: "dotted" },
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "ถึง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  " + dataReport[0].assessmentEndDate + "  ",
                                                                underline: { type: "dotted" },
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new ImageRun({
                                                                data: handlerCheck(dataReport[0].assessmentFlag2),
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "เมื่อสิ้นสุดสัญญา",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c4 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "สัญญา",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: " " + dataReport[0].contractNo + " ",
                                                                underline: { type: "dotted" },
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1.2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  วันที่ลงนามในสัญญา",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: " " + dataReport[0].contractSignDate + " ",
                                                                underline: { type: "dotted" },
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c5 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        borders: cellBorder.noBorder,
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "ผู้รับจ้าง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: " " + dataReport[0].contractorName + " ",
                                                                underline: { type: "dotted" },
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(0.7),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  ลักษณะงาน  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(0.3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(dataReport[0].pipeType1),
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(0.7),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  ท่อประธาน  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(0.3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(dataReport[0].pipeType2),
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(0.7),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  ท่อจ่ายน้ำ  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(0.3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: handlerCheck(dataReport[0].pipeType3),
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(0.7),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  ท่อบริการ  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c6 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "วันที่เริ่มงาน  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: " " + dataReport[0].contractBeginDate + " ",
                                                                underline: { type: "dotted" },
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  วันที่สิ้นสุดสัญญา  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: " " + dataReport[0].contractEndDate + " ",
                                                                underline: { type: "dotted" },
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  วงเงินค่างาน  ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: " " + dataReport[0].contractAmount + " ",
                                                                underline: { type: "dotted" },
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(0.7),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  บาท",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c7 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                margins: { right: convertInchesToTwip(0.1) },
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "right",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "วันที่งานแล้วเสร็จจริง",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(7),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: " " + dataReport[0].actualEndDate + " ",
                                                                underline: { type: "dotted" },
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const titleC8 = ["ข้อ", "หัวข้อพิจารณา", "น้ำหนัก", "คะแนนที่ได้", "หมายเหตุ"];

    const setTable = new Table({
        rows: [
            new TableRow({
                children: titleC8.map((item, index) => {
                    return new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        size: font.size.tbHeader,
                                        text: item,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    });
                }),
            }),
        ],
    });

    for (const iterator of dataReport) {
        setTable.root.push(
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        size: font.size.tbHeader,
                                        text: iterator.criteriaNo === 999 ? "" : iterator.criteriaNo,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        margins: { left: convertInchesToTwip(0.1) },
                        width: {
                            size: convertInchesToTwip(3.2),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        size: font.size.tbHeader,
                                        text: iterator.criteriaDesc,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        size: font.size.tbHeader,
                                        text: iterator.criteriaWeight,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        size: font.size.tbHeader,
                                        text: iterator.criteriaScore,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        margins: { left: convertInchesToTwip(0.1) },
                        width: {
                            size: convertInchesToTwip(3),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        size: font.size.tbHeader,
                                        text: iterator.criteriaRemark,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            })
        );
    }

    const sum_criteriaWeight = () => {
        let sum = 0;
        for (const iterator of dataReport) {
            sum += iterator.criteriaWeight;
        }
        return sum;
    };

    setTable.root.push(
        new TableRow({
            children: [
                new TableCell({
                    columnSpan: 2,
                    width: {
                        size: convertInchesToTwip(1),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: "center",
                            children: [
                                new TextRun({
                                    size: font.size.tbHeader,
                                    text: "",
                                }),
                            ],
                        }),
                    ],
                }),
                new TableCell({
                    width: {
                        size: convertInchesToTwip(1),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: "center",
                            children: [
                                new TextRun({
                                    size: font.size.tbHeader,
                                    text: sum_criteriaWeight(),
                                    font: font.SarabunPSK,
                                }),
                            ],
                        }),
                    ],
                }),
                new TableCell({
                    width: {
                        size: convertInchesToTwip(1),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: "center",
                            children: [
                                new TextRun({
                                    size: font.size.tbHeader,
                                    text: "",
                                }),
                            ],
                        }),
                    ],
                }),
                new TableCell({
                    margins: { left: convertInchesToTwip(0.1) },
                    borders: {
                        bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                    },
                    width: {
                        size: convertInchesToTwip(3),
                        type: WidthType.DXA,
                    },
                    children: [
                        new Paragraph({
                            alignment: "center",
                            children: [
                                new TextRun({
                                    size: font.size.tbHeader,
                                    text: "ถูกตัดคะแนนสะสม  " + dataReport[0].deductScore,
                                    font: font.SarabunPSK,
                                }),
                            ],
                        }),
                    ],
                }),
            ],
        })
    );

    const c8 = new Table({
        rows: [
            new TableRow({
                margins: { top: convertInchesToTwip(0.1) },
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [setTable],
                    }),
                ],
            }),
        ],
    });

    const c9 = new Table({
        margins: {
            top: convertInchesToTwip(0.1),
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "ผลงานที่ทำได้",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: pdfImage.unchecked,
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  เร็วกว่าแผนสัญญา ........",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "    ",
                                                                underline: {
                                                                    type: "dotted",
                                                                },
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: pdfImage.unchecked,
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  ทันตามแผนสัญญา",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: pdfImage.unchecked,
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  ช้ากว่าแผนสัญญา .............",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const c10 = new Table({
        margins: {
            top: convertInchesToTwip(0.1),
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(1),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "ผลการประเมิน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(2),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: pdfImage.unchecked,
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  ผ่านการประเมิน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),

                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new ImageRun({
                                                                data: pdfImage.unchecked,
                                                                transformation: {
                                                                    width: 15,
                                                                    height: 15,
                                                                },
                                                            }),
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  ไม่ผ่านการประเมิน",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: "  ค่าปรับ",
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: dataReport[0].fineAmount == null ? "    " : dataReport[0].fineAmount,
                                                                font: font.SarabunPSK,
                                                            }),
                                                            new TextRun({
                                                                size: font.size.p,
                                                                text: " บาท",
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const label11_2 = ["เรียน ผอ.ฝ่ายฯ/ผจ.สส......", "        เพื่อโปรดพิจารณาให้ความเห็นชอบ", "ลงชื่อ ......................................... ", "        ( ......................................... )", "ตำเเหน่ง(ผอ.กองฯ)", "วันที่ ........................................."];

    const c11 = new Table({
        margins: {
            top: convertInchesToTwip(0.1),
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Table({
                                                        rows: [
                                                            new TableRow({
                                                                children: [
                                                                    new TableCell({
                                                                        borders: cellBorder.noBorder,
                                                                        width: {
                                                                            size: convertInchesToTwip(5),
                                                                            type: WidthType.DXA,
                                                                        },
                                                                        children: [
                                                                            new Paragraph({
                                                                                alignment: "left",
                                                                                children: [
                                                                                    new TextRun({
                                                                                        size: font.size.p,
                                                                                        bold: true,
                                                                                        text: "ข้อสรุปและวิจารณ์",
                                                                                        font: font.SarabunPSK,
                                                                                    }),
                                                                                ],
                                                                            }),
                                                                        ],
                                                                    }),
                                                                ],
                                                            }),
                                                            new TableRow({
                                                                children: [
                                                                    new TableCell({
                                                                        borders: cellBorder.noBorder,
                                                                        width: {
                                                                            size: convertInchesToTwip(5),
                                                                            type: WidthType.DXA,
                                                                        },
                                                                        children: [
                                                                            new Paragraph({
                                                                                alignment: "left",
                                                                                children: [
                                                                                    new TextRun({
                                                                                        size: font.size.p,
                                                                                        bold: true,
                                                                                        text: " " + dataReport[0].assessmentDetail + " ",
                                                                                        font: font.SarabunPSK,
                                                                                    }),
                                                                                ],
                                                                            }),
                                                                        ],
                                                                    }),
                                                                ],
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Table({
                                                        rows: label11_2.map((item, index) => {
                                                            return new TableRow({
                                                                children: [
                                                                    new TableCell({
                                                                        borders: cellBorder.noBorder,
                                                                        width: {
                                                                            size: convertInchesToTwip(5),
                                                                            type: WidthType.DXA,
                                                                        },
                                                                        children: [
                                                                            new Paragraph({
                                                                                alignment: "center",
                                                                                children: [
                                                                                    new TextRun({
                                                                                        size: font.size.p,
                                                                                        bold: true,
                                                                                        text: item,
                                                                                        font: font.SarabunPSK,
                                                                                    }),
                                                                                ],
                                                                            }),
                                                                        ],
                                                                    }),
                                                                ],
                                                            });
                                                        }),
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const label12_1 = ["เรียน (ผอ.กองฯ)", "เพื่อโปรดพิจาณา", "ลงชื่อ .........................................", "        ( ......................................... )", "วิศวกรผู้ควบคุมงาน", "วันที่ ........................................."];
    const label12_2 = ["", "เห็นชอบผลการประเมิน", "ลงชื่อ .........................................", "        ( ......................................... )", "ตำแหน่ง (ผอ.ฝ่ายฯ/ผจ.สส)", "วันที่ ........................................."];

    const c12 = new Table({
        margins: {
            top: convertInchesToTwip(0.1),
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Table({
                                                        rows: label12_1.map((item, index) => {
                                                            return new TableRow({
                                                                children: [
                                                                    new TableCell({
                                                                        borders: cellBorder.noBorder,
                                                                        width: {
                                                                            size: convertInchesToTwip(5),
                                                                            type: WidthType.DXA,
                                                                        },
                                                                        children: [
                                                                            new Paragraph({
                                                                                alignment: "center",
                                                                                children: [
                                                                                    new TextRun({
                                                                                        size: font.size.p,
                                                                                        bold: true,
                                                                                        text: item,
                                                                                        font: font.SarabunPSK,
                                                                                    }),
                                                                                ],
                                                                            }),
                                                                        ],
                                                                    }),
                                                                ],
                                                            });
                                                        }),
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Table({
                                                        rows: label12_2.map((item, index) => {
                                                            return new TableRow({
                                                                children: [
                                                                    new TableCell({
                                                                        borders: cellBorder.noBorder,
                                                                        width: {
                                                                            size: convertInchesToTwip(5),
                                                                            type: WidthType.DXA,
                                                                        },
                                                                        children: [
                                                                            new Paragraph({
                                                                                alignment: "center",
                                                                                children: [
                                                                                    new TextRun({
                                                                                        size: font.size.p,
                                                                                        bold: true,
                                                                                        text: item,
                                                                                        font: font.SarabunPSK,
                                                                                    }),
                                                                                ],
                                                                            }),
                                                                        ],
                                                                    }),
                                                                ],
                                                            });
                                                        }),
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const label13_1 = [
        "ที่ .......... / .......... วันที่ ................................. ",
        "",
        "เพื่อทราบและดำเนินการต่อไป",
        "ลงชื่อ .........................................",
        "( ......................................... )",
        "ตำแหน่ง(ผอ.ฝ่ายฯ/ผจ.สส) ......",
        "วันที่ .........................................",
    ];
    const label13_2 = ["", "เรียน ................................. ", "เพื่อดำเนินการต่อไป", "ลงชื่อ .........................................", "( ......................................... )", "ตำแหน่ง ผอ.ศปส.", "วันที่ ........................................."];

    const c13 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: {
                                                    left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                    top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                },
                                                width: {
                                                    size: convertInchesToTwip(4.3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Table({
                                                        rows: label13_1.map((item, index) => {
                                                            if (index === 1) {
                                                                return new TableRow({
                                                                    children: [
                                                                        new TableCell({
                                                                            verticalAlign: "bottom",
                                                                            margins: {
                                                                                top: convertInchesToTwip(0.1),
                                                                            },
                                                                            borders: cellBorder.noBorder,
                                                                            width: {
                                                                                size: convertInchesToTwip(4.3),
                                                                                type: WidthType.DXA,
                                                                            },
                                                                            children: [
                                                                                new Paragraph({
                                                                                    alignment: "center",
                                                                                    children: [
                                                                                        new TextRun({
                                                                                            size: font.size.p,
                                                                                            text: "เรียน  ",
                                                                                            font: font.SarabunPSK,
                                                                                        }),
                                                                                        new ImageRun({
                                                                                            data: pdfImage.unchecked,
                                                                                            transformation: { width: 15, height: 15 },
                                                                                        }),
                                                                                        new TextRun({
                                                                                            size: font.size.p,
                                                                                            text: "  ผอ.ศปส.  ",
                                                                                            font: font.SarabunPSK,
                                                                                        }),
                                                                                        new ImageRun({
                                                                                            data: pdfImage.unchecked,
                                                                                            transformation: { width: 15, height: 15 },
                                                                                        }),
                                                                                        new TextRun({
                                                                                            size: font.size.p,
                                                                                            text: "  ผอ.กธบ.",
                                                                                            font: font.SarabunPSK,
                                                                                        }),
                                                                                    ],
                                                                                }),
                                                                            ],
                                                                        }),
                                                                    ],
                                                                });
                                                            } else {
                                                                return new TableRow({
                                                                    children: [
                                                                        new TableCell({
                                                                            verticalAlign: "bottom",
                                                                            borders: index === 0 ? cellBorder.borderButton : cellBorder.noBorder,
                                                                            width: {
                                                                                size: convertInchesToTwip(5),
                                                                                type: WidthType.DXA,
                                                                            },
                                                                            children: [
                                                                                new Paragraph({
                                                                                    alignment: "center",
                                                                                    children: [
                                                                                        new TextRun({
                                                                                            size: font.size.p,
                                                                                            bold: true,
                                                                                            text: item,
                                                                                            font: font.SarabunPSK,
                                                                                        }),
                                                                                    ],
                                                                                }),
                                                                            ],
                                                                        }),
                                                                    ],
                                                                });
                                                            }
                                                        }),
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: {
                                                    left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                    top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Table({
                                                        rows: label13_2.map((item, index) => {
                                                            return new TableRow({
                                                                children: [
                                                                    new TableCell({
                                                                        borders: cellBorder.noBorder,
                                                                        width: {
                                                                            size: convertInchesToTwip(5),
                                                                            type: WidthType.DXA,
                                                                        },
                                                                        children: [
                                                                            new Paragraph({
                                                                                alignment: "center",
                                                                                children: [
                                                                                    new TextRun({
                                                                                        size: font.size.p,
                                                                                        bold: true,
                                                                                        text: item,
                                                                                        font: font.SarabunPSK,
                                                                                    }),
                                                                                ],
                                                                            }),
                                                                        ],
                                                                    }),
                                                                ],
                                                            });
                                                        }),
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const label14_1 = ["หมายเหตุ - ผลงานที่ทำได้ ส่วนที่ข้าเร็วกว่าแผน/สัญญา", "หากเป็นการประเมินผลระหว่างก่อสร้างให้ระบุ เป็นร้อยละหากเป็นการประเมินผลเมื่อสิ้นสุดงาน", "ในสัญญาให้ระบุเป็นจำนวนวัน"];
    const label14_2 = ["", ".........................................", "( ......................................... )", "ตำแหน่ง .........................................", "วันที่ตรวจสอบ ........................................."];

    const c14 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: {
                                                    left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                    top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                },
                                                width: {
                                                    size: convertInchesToTwip(4),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Table({
                                                        rows: label14_1.map((item, index) => {
                                                            return new TableRow({
                                                                children: [
                                                                    new TableCell({
                                                                        borders: cellBorder.noBorder,
                                                                        width: {
                                                                            size: convertInchesToTwip(4),
                                                                            type: WidthType.DXA,
                                                                        },
                                                                        children: [
                                                                            new Paragraph({
                                                                                alignment: "left",
                                                                                children: [
                                                                                    new TextRun({
                                                                                        size: font.size.p,
                                                                                        bold: true,
                                                                                        text: item,
                                                                                        font: font.SarabunPSK,
                                                                                    }),
                                                                                ],
                                                                            }),
                                                                        ],
                                                                    }),
                                                                ],
                                                            });
                                                        }),
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: {
                                                    left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                    top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                                                },
                                                width: {
                                                    size: convertInchesToTwip(5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Table({
                                                        rows: label14_2.map((item, index) => {
                                                            if (index === 0) {
                                                                return new TableRow({
                                                                    children: [
                                                                        new TableCell({
                                                                            borders: cellBorder.noBorder,
                                                                            width: {
                                                                                size: convertInchesToTwip(5),
                                                                                type: WidthType.DXA,
                                                                            },
                                                                            children: [
                                                                                new Paragraph({
                                                                                    alignment: "center",
                                                                                    children: [
                                                                                        new TextRun({
                                                                                            size: font.size.p,
                                                                                            bold: true,
                                                                                            text: "ผลการตรวจสอบการประเมิน ",
                                                                                            font: font.SarabunPSK,
                                                                                        }),
                                                                                        new ImageRun({
                                                                                            data: pdfImage.unchecked,
                                                                                            transformation: { width: 15, height: 15 },
                                                                                        }),
                                                                                        new TextRun({
                                                                                            size: font.size.p,
                                                                                            bold: true,
                                                                                            text: "ไม่มีการแก้ไข ",
                                                                                            font: font.SarabunPSK,
                                                                                        }),
                                                                                        new ImageRun({
                                                                                            data: pdfImage.unchecked,
                                                                                            transformation: { width: 15, height: 15 },
                                                                                        }),
                                                                                        new TextRun({
                                                                                            size: font.size.p,
                                                                                            bold: true,
                                                                                            text: "มีการแก้ไขและแก้ไขแล้ว ",
                                                                                            font: font.SarabunPSK,
                                                                                        }),
                                                                                    ],
                                                                                }),
                                                                            ],
                                                                        }),
                                                                    ],
                                                                });
                                                            } else {
                                                                return new TableRow({
                                                                    children: [
                                                                        new TableCell({
                                                                            borders: cellBorder.noBorder,
                                                                            width: {
                                                                                size: convertInchesToTwip(5),
                                                                                type: WidthType.DXA,
                                                                            },
                                                                            children: [
                                                                                new Paragraph({
                                                                                    alignment: "center",
                                                                                    children: [
                                                                                        new TextRun({
                                                                                            size: font.size.p,
                                                                                            bold: true,
                                                                                            text: item,
                                                                                            font: font.SarabunPSK,
                                                                                        }),
                                                                                    ],
                                                                                }),
                                                                            ],
                                                                        }),
                                                                    ],
                                                                });
                                                            }
                                                        }),
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const label15 = ["คำชี้แจงในการประเมินผลงานก่อสร้างของผู้รับจ้าง (แบบประเมินที่ 1)", "สำหรับงานก่อสร้างวางท่อจ่ายน้ำกับท่อบริการที่มีค่างาน", "ผู้ประเมินโปรดอ่านคำชี้แจงนี้ โดยละเอียดและปฏิบัติตามขั้นตอนและหลักเกณฑ์ในการพิจารณาผลงานก่อสร้างของผู้รับจ้าง", "ประกอบการให้คะแนนด้วย"];

    const c15 = new Table({
        rows: label15.map((item, index) => {
            return new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(10),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: index === 0 || index === 1 ? "center" : "left",
                                children: [
                                    new TextRun({
                                        text: item,
                                        size: font.size.p,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            });
        }),
    });
    const label16 = [
        { no: "1.", label: "ผู้ประเมินผลต้องเป็นผู้ควบคุมงาน(นายช่างโครงการ) และจะต้องวิจารณ์สรุปผลการปฏิบัติงานของผู้รับจ้าง เสนอผู้บังคับบัญชาตามระดับชั้นจนถึงผู้อำนวยการฝ่าย / ผู้จัดการสำนักงานประปาสาขา ให้ความเห็นชอบ" },
        {
            no: "2.",
            label: "ในกรณีประเมินผลระหว่างก่อสร้างสำหรับสัญญาที่มีค่างานมากกว่า 6 แสนบาท ถึง 10 ล้านบาท ระยะเวลาการประเมินผลให้นับตั้งแต่วันที่แจ้งให้เริ่มงานหรือถัดจากวันที่มีการประเมินผลในคราวก่อนไปอีกเป็นเวลา 6 เดือน และสำหรับสัญญาที่มีค่างานน้อยกว่า 6 แสนบาทให้ดำเนินการประเมินครั้งเดียวเมื่องานแล้วเสร็จทั้งสัญญา",
        },
        { no: "3.", label: "ในกรณีประเมินผลเมื่อสิ้นสุดงานในสัญญาระยะเวลาการประเมินผลให้นับตั้งแต่วันที่แจ้งให้เริ่มงานในสัญญาช้างจนถึงวันที่คณะกรรมการตรวจการจ้างตรวจรับงานงวดสุดท้ายแล้ว หรือตามที่กำหนดในหลักเกณฑ์ฯ" },
        { no: "4.", label: "การประเมินผลงานก่อสร้างจะต้องนำการตัดคะแนนผู้รับจ้าง ตามหลักเกณฑ์การตัดคะแนนในกรณีต่างๆ มาประกอบการพิจารณาด้วย" },
        { no: "5.", label: "คะแนนทั่วไปที่กำหนดให้ ดีมาก 5 คะแนน, ดี 4 คะแนน, พอใช้ 3 คะแนน, ปรับปรุง 2 คะแนน, ต้องแก้ไข 1 คะแนน" },
        { no: "6.", label: `การให้คะแนน ให้ลงคะแนน 1 - 5 ในช่องที่ต้องการเพียงช่องเดียวต่อหนึ่งหัวข้อ โดยใช้ "เกณฑ์ในการพิจารณาประเมินผลงานก่อสร้างของผู้รับจ้าง "ทุกหัวข้อ"` },
        { no: "7.", label: "หัวข้อหรือรายการใดที่ไม่เกี่ยวข้องกับงานหรือไม่มีขั้นตอนของงานนั้น ไม่ต้องให้คะแนนใดๆ" },
        { no: "8.", label: "การคิดคะแนนตามขั้นตอนสุดท้าย เพื่อพิจารณาตามเกณฑ์ที่จะผ่านการประเมินผลนั้น หากมีจุดทศนิยมให้ปัดเป็นจำานวนเต็มก่อนการพิจารณา" },
        { no: "9.", label: "เกณฑ์ที่จะผ่านการประเมินผลนั้น ถือเกณฑ์คะแบบ 60" },
    ];

    const c16 = new Table({
        rows: label16.map((item, index) => {
            return new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(0.1),
                            type: WidthType.DXA,
                        },
                        borders: cellBorder.noBorder,
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        text: item.no,
                                        size: font.size.p,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(9.9),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        text: item.label,
                                        size: font.size.p,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            });
        }),
    });

    const titleTableC17 = [
        { l: "ลำดับที่", w: 1 },
        { l: "รายการประเมินผล", w: 3 },
        { l: "น้ำหนัก", w: 1 },
        { l: "น้ำหนักXคะแนน", w: 1 },
        { l: "ดีมาก(5)", w: 1 },
        { l: "ดีมาก(4)", w: 1 },
        { l: "ดีมาก(3)", w: 1 },
        { l: "ดีมาก(2)", w: 1 },
        { l: "ดีมาก(1)", w: 1 },
    ];

    const c17 = new Table({
        rows: [
            new TableRow({
                tableHeader: true,
                children: titleTableC17.map((item, index) => {
                    return new TableCell({
                        width: {
                            size: convertInchesToTwip(item.w),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: item.l,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    });
                }),
            }),
        ],
    });
    let index = 0;
    let TotalItemWeight = 0;
    let TotalItemPoint = 0;

    const addRowTotalWeight = (Weight) => {
        c17.root.push(
            new TableRow({
                children: [
                    new TableCell({
                        borders: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(2),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "รวม",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: Weight,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "",
                                        size: font.size.tbbody,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        columnSpan: 5,
                        borders: {
                            bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                ],
            })
        );
    };
    const addRowTotalPoint = (Point) => {
        c17.root.push(
            new TableRow({
                children: [
                    new TableCell({
                        borders: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "",
                                        size: font.size.tbbody,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(3),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                rowSpan: 2,
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [new TextRun({ size: font.size.p, text: "คะแนนที่ได้=", font: font.SarabunPSK })],
                                                    }),
                                                ],
                                            }),
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [new TextRun({ size: font.size.p, text: "รวม(น้ำหนัก X คะแนน) = ", font: font.SarabunPSK, underline: { type: "line" } })],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                borders: cellBorder.noBorder,
                                                children: [
                                                    new Paragraph({
                                                        alignment: "center",
                                                        children: [new TextRun({ text: "5" })],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "",
                                        size: font.size.tbbody,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: {
                            top: {},
                        },
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: Point,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: {
                            top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },
                        },
                        columnSpan: 5,
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                ],
            })
        );
    };

    for (const item of dataRPTScore) {
        if (item.itemWeight !== null) {
            TotalItemWeight += item.itemWeight;
            TotalItemPoint += item.itemPoint;
        }

        if (item.itemGroupId !== "" && index > 0) {
            addRowTotalWeight(TotalItemWeight);
            addRowTotalPoint(TotalItemPoint);
            TotalItemWeight = 0;
            TotalItemPoint = 0;
        }

        c17.root.push(
            new TableRow({
                children: [
                    new TableCell({
                        borders: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: item.itemGroupId,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(2),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        text: item.itemDesc,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: item.itemWeight,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: item.itemPoint,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: item.itemScore5 === "Y" ? "X" : "",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: item.itemScore4 === "Y" ? "X" : "",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: item.itemScore3 === "Y" ? "X" : "",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: item.itemScore2 === "Y" ? "X" : "",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(1),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: item.itemScore1 === "Y" ? "X" : "",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            })
        );
        index++;
    }

    addRowTotalWeight(TotalItemWeight);
    addRowTotalPoint(TotalItemPoint);

    const brack = new Paragraph({
        children: [new TextRun(""), new PageBreak()],
    });

    const space = new Paragraph({
        children: [],
    });

    const doc = new Document({
        sections: [
            {
                children: [c, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11, c12, c13, c14, brack, c15, space, c16, space, c17],
                properties: {
                    page: {
                        margin: {
                            top: convertInchesToTwip(0.5),
                            right: convertInchesToTwip(0.5),
                            bottom: convertInchesToTwip(0.5),
                            left: convertInchesToTwip(0.5),
                        },
                    },
                    type: WidthType.DXA,
                },
            },
        ],
    });

    Packer.toBlob(doc).then((blob) => {
        setLoading(false);
        saveAs(blob, "PRT245.docx");
    });
};
